import React from "react";
import { containerClassName } from "@/lib/container";

export const Section = ({ id, className = "", innerClassName = "", children }) => {
  return (
    <section id={id} className={`w-full ${className}`}>
      <div className={`${containerClassName} ${innerClassName}`}>{children}</div>
    </section>
  );
};

export default Section;
